import { Box, Card, CardBody, Divider, Heading, HStack, Text, VStack } from '@chakra-ui/react'
import type { DashboardTodoItem } from './types'

type DashboardTodoSectionProps = {
  title: string
  items: DashboardTodoItem[]
  cardBg: string
  textColor: string
  subtitleColor: string
  borderColor: string
  hoverBg: string
  onNavigate: (path: string) => void
  formatValue: (value: number | null | undefined) => string
}

export function DashboardTodoSection(props: DashboardTodoSectionProps) {
  const {
    title,
    items,
    cardBg,
    textColor,
    subtitleColor,
    borderColor,
    hoverBg,
    onNavigate,
    formatValue,
  } = props

  return (
    <Card bg={cardBg} borderRadius="xl" boxShadow="sm">
      <CardBody p={{ base: 4, md: 6 }}>
        <Heading size={{ base: 'sm', md: 'md' }} mb={4} color={textColor}>
          {title}
        </Heading>
        <VStack align="stretch" spacing={3}>
          {items.map((item, index) => (
            <Box
              key={item.label}
              cursor="pointer"
              onClick={() => onNavigate(item.path)}
              _hover={{ bg: hoverBg }}
              borderRadius="md"
              px={2}
              py={1}
              mx={{ base: 0, md: -2 }}
            >
              <HStack justify="space-between" minW={0}>
                <Text fontSize="sm" color={subtitleColor} minW={0} overflowWrap="anywhere">
                  {item.label}
                </Text>
                <Text fontSize="sm" fontWeight="semibold" color={textColor} flexShrink={0}>
                  {formatValue(item.value)}
                </Text>
              </HStack>
              {index !== items.length - 1 && (
                <Divider mt={3} borderColor={borderColor} />
              )}
            </Box>
          ))}
        </VStack>
      </CardBody>
    </Card>
  )
}
